import { useDispatch as useDispatchHook } from 'react-redux'
// Internal
import type { AppDispatch } from 'store'

const useDispatch = (): ReturnType<typeof useDispatchHook> => useDispatchHook<AppDispatch>()

export default useDispatch
